<trg-breadcrumb [breadcrumbsList]="breadcrumbsList" [jsonLD]="jsonLD" (pageIndex)="goToUrl($event)"></trg-breadcrumb>
